// Generated by GitHub Copilot

/**
 * Builds the public accept-invitation URL the inviter shares manually.
 * No email is sent on invite, so this link is the only way the invitee joins;
 * it points at the `_public/accept-invitation` route with the one-time token.
 */
export function buildInvitationAcceptUrl(token: string): string {
  return `${window.location.origin}/accept-invitation?token=${encodeURIComponent(token)}`
}
